import styled from 'styled-components';
import { useContext } from 'react';
import RestaurantContext from '../../Context/RestaurantContext';
import getRestaurantStatusText from '../../util/storeStatusHelper';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;

  justify-content: center;

  @media (min-width: 576px) {
    align-items: center;
  }

  padding: 20px;

  background-color: RGBA(236, 151, 31, 0.1);

  span {
    display: block;
    margin: 0;
    color: #ec971f;
    font-size: 15px;
    letter-spacing: 0.67px;
    font-weight: 500;
  }
  span {
    display: block;
    margin: 0;
    color: #ec971f;
    font-size: 15px;
    letter-spacing: 0.67px;
    font-weight: 500;
  }
  p {
    margin: 0;
    color: #ec971f;
    font-size: 19px;
    letter-spacing: 0.84px;
    font-weight: 700;
  }
`;

const StoreStatusComponent = () => {
  const { restaurantProps: storeProps, getOverallStatus } = useContext(RestaurantContext);

  if (getOverallStatus(storeProps) === 'OPEN') {
    return null;
  }
  // Nutze die Logik aus getRestaurantStatusText, aber extrahiere nur den JSX-Output OHNE das Styling
  const statusContent = getRestaurantStatusText(storeProps, false); // Übergib false, um das Styled-Wrapper zu deaktivieren

  return <Wrapper>{statusContent}</Wrapper>;
};

export default StoreStatusComponent;
